export const primengTexts = {
	'fr-FR': {
		"accept": "Oui",
		"addRule": "Add Rule",
		"after": "Après",
		"am": "am",
		"apply": "Appliquer",
		"before": "Avant",
		"cancel": "Annuler",
		"choose": "Sélectionner",
		"clear": "Vider",
		"contains": "Contenant",
		"dateAfter": "Date est après",
		"dateBefore": "Date est avant",
		"dateFormat": "dd/mm/yy",
		"dateIs": "Date est",
		"dateIsNot": "Date n'est pas",
		"dayNames": [
			"Dimanche",
			"Lundi",
			"Mardi",
			"Mercredi",
			"Jeudi",
			"Vendredi",
			"Samedi"
		],
		"dayNamesMin": [
			"Di",
			"Lu",
			"Ma",
			"Me",
			"Je",
			"Ve",
			"Sa"
		],
		"dayNamesShort": [
			"Dim",
			"Lun",
			"Mar",
			"Mer",
			"Jeu",
			"Ven",
			"Sam"
		],
		"emptyFilterMessage": "Aucun résultat",
		"emptyMessage": "Aucun choix disponible",
		"emptySearchMessage": "Aucun résultat",
		"emptySelectionMessage": "Aucun choix sélectionné",
		"endsWith": "Finissant par",
		"equals": "Egal",
		"fileChosenMessage": "Fichiers",
		"fileSizeTypes": [
			"o",
			"Ko",
			"Mo",
			"Go",
			"To",
			"Po",
			"Eo",
			"Zo",
			"Yo"
		],
		"firstDayOfWeek": 1,
		"gt": "Supérieur à ",
		"gte": "Supérieur ou égal à",
		"invalidFileLimitMessageDetail": "{0} fichiers maximum.",
		"invalidFileLimitMessageSummary": "Le nombre de fichiers sélectionnés dépasse la limite.",
		"invalidFileSizeMessageDetail": "Taille maximum autorisée : {0}.",
		"invalidFileSizeMessageSummary": "{0}: Taille de fichier invalide",
		"invalidFileTypeMessageDetail": "Fichiers autorisés : {0}",
		"invalidFileTypeMessageSummary": "{0}: Type de fichier invalide.",
		"is": "Est",
		"isNot": "N'est pas",
		"lt": "Inférieur à",
		"lte": "Inférieur ou égal à",
		"matchAll": "Tous",
		"matchAny": "Au moins un",
		"medium": "Moyen",
		"monthNames": [
			"Janvier",
			"Février",
			"Mars",
			"Avril",
			"Mai",
			"Juin",
			"Juillet",
			"Août",
			"Septembre",
			"Octobre",
			"Novembre",
			"Décembre"
		],
		"monthNamesShort": [
			"Jan",
			"Fév",
			"Mar",
			"Avr",
			"Mai",
			"Juin",
			"Juil",
			"Août",
			"Sep",
			"Oct",
			"Nov",
			"Déc"
		],
		"noFileChosenMessage": "Aucun fichier sélectionné",
		"noFilter": "Aucun filtre",
		"notContains": "Ne contenant pas",
		"notEquals": "Différent",
		"passwordPrompt": "Saississez un mot de passe",
		"pending": "En attente",
		"pm": "pm",
		"reject": "Non",
		"removeRule": "Remove Rule",
		"searchMessage": "Des résultats sont disponibles",
		"selectionMessage": "{0} objets sélectionnés",
		"startsWith": "Commençant par",
		"strong": "Fort",
		"today": "Aujourd'hui",
		"upload": "Envoyer",
		"weak": "Faible",
		"weekHeader": "Sem"
	},
	'en': {
		"accept": "Yes",
		"addRule": "Add Rule",
		"after": "After",
		"am": "am",
		"apply": "Apply",
		"before": "Before",
		"cancel": "Cancel",
		"choose": "Choose",
		"clear": "Clear",
		"contains": "Contains",
		"dateAfter": "Date is after",
		"dateBefore": "Date is before",
		"dateFormat": "yy-mm-dd",
		"dateIs": "Date is",
		"dateIsNot": "Date is not",
		"dayNames": [
			"Sunday",
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday"
		],
		"dayNamesMin": [
			"Su",
			"Mo",
			"Tu",
			"We",
			"Th",
			"Fr",
			"Sa"
		],
		"dayNamesShort": [
			"Sun",
			"Mon",
			"Tue",
			"Wed",
			"Thu",
			"Fri",
			"Sat"
		],
		"emptyFilterMessage": "No results found",
		"emptyMessage": "No results found",
		"emptySearchMessage": "No results found",
		"emptySelectionMessage": "No selected item",
		"endsWith": "Ends with",
		"equals": "Equals",
		"fileChosenMessage": "Files",
		"fileSizeTypes": [
			"B",
			"KB",
			"MB",
			"GB",
			"TB",
			"PB",
			"EB",
			"ZB",
			"YB"
		],
		"firstDayOfWeek": 1,
		"gt": "Greater than",
		"gte": "Greater than or equal to",
		"invalidFileLimitMessageDetail": "limit is {0} at most.",
		"invalidFileLimitMessageSummary": "Maximum number of files exceeded, ",
		"invalidFileSizeMessageDetail": "maximum upload size is {0}.",
		"invalidFileSizeMessageSummary": "{0}: Invalid file size, ",
		"invalidFileTypeMessageDetail": "allowed file types: {0}.",
		"invalidFileTypeMessageSummary": "{0}: Invalid file type, ",
		"is": "Is",
		"isNot": "Is not",
		"lt": "Less than",
		"lte": "Less than or equal to",
		"matchAll": "Match All",
		"matchAny": "Match Any",
		"medium": "Medium",
		"monthNames": [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July",
			"August",
			"September",
			"October",
			"November",
			"December"
		],
		"monthNamesShort": [
			"Jan",
			"Feb",
			"Mar",
			"Apr",
			"May",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Oct",
			"Nov",
			"Dec"
		],
		"noFileChosenMessage": "No file chosen",
		"noFilter": "No Filter",
		"notContains": "Not contains",
		"notEquals": "Not equals",
		"passwordPrompt": "Enter a password",
		"pending": "Pending",
		"pm": "pm",
		"reject": "No",
		"removeRule": "Remove Rule",
		"searchMessage": "Search results are available",
		"selectionMessage": "{0} items selected",
		"startsWith": "Starts with",
		"strong": "Strong",
		"today": "Today",
		"upload": "Upload",
		"weak": "Weak",
		"weekHeader": "Wk"
	}
};
